import { arrayOf, shape, string } from 'prop-types';
import React, { Fragment } from 'react';
import AmpTeaser from 'components/AmpTeaser';
import styles from './styles';

function AmpRecipeRoundup(props) {
  const { id, recipes, subsectionDescription, subsectionTitle } = props;
  if (!recipes) {
    return null;
  }
  return (
    <Fragment>
      <h2 id={`${id}`} dangerouslySetInnerHTML={{ __html: subsectionTitle }} />
      <p dangerouslySetInnerHTML={{ __html: subsectionDescription }} />
      {recipes.map(recipe => (
        <div key={recipe.url} className="Teaser--recipeRoundup Teaser--action">
          <a
            className="Teaser__headline Teaser__link"
            title={recipe.title}
            href={recipe.url}
          >
            <div className="Teaser__picture">
              <AmpTeaser
                headline={recipe.title}
                imageUrl={recipe.imageUrl}
                dek={recipe.description}
                imgProps={{
                  maxSize: {
                    width: 100,
                    aspectRatio: 1
                  }
                }}
                originalHeight={300}
                originalWidth={300}
                cta="Go To The Recipe"
                variant="recipeRoundup"
              />
            </div>
          </a>
        </div>
      ))}
      <style jsx>{styles}</style>
    </Fragment>
  );
}

AmpRecipeRoundup.propTypes = {
  id: string.isRequired,
  subsectionTitle: string.isRequired,
  subsectionDescription: string.isRequired,
  recipes: arrayOf(
    shape({
      title: string,
      imageUrl: string,
      description: string,
      url: string
    })
  )
};

AmpRecipeRoundup.defaultProps = {
  recipes: undefined
};

export default AmpRecipeRoundup;
